export const floatWindowAdapter = module => {
  if (module.data && module.data[0]) {
    module.data[0].width = 160
    module.data[0].height = 160
  }
  return module
}
